"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const actionCreators = __importStar(require("./actions"));
const consts_1 = require("./consts");
const initialState = {
    selectedTool: consts_1.TOOL_STATE.NAVIGATE,
    selectedItem: null,
    undos: 0,
    redos: 0,
    drawingAngled: false,
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.selectTool): {
            draft.selectedTool = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.selectItem): {
            draft.selectedItem = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateUndos): {
            draft.undos = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateRedos): {
            draft.redos = action.payload;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateDrawingAngled): {
            draft.drawingAngled = action.payload;
            // eslint-disable-next-line no-useless-return
            return;
        }
        default: {
            // eslint-disable-next-line no-useless-return
            return;
        }
    }
});
exports.default = reducer;
